export default {"src":"/_next/static/media/WalletAsAService.61b2cc8a.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};